import {LocalDateTime} from 'js-joda'
import {Decoder, field, object, string} from 'json-bouncer'
import {localDateTimeDecoder} from './DecodeHelper'

export interface Authentication {
    readonly token: string
    readonly expires: LocalDateTime
}

export function authenticationDecoder(): Decoder<Authentication> {
    return object({
        token: field('token', string()),
        expires: field('expires', localDateTimeDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/Authentication.ts